import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { GET_VENDOR_MEMBERS_REQUEST } from "./type";
import { getVendorMembersSuccess, getVendorMembersFailure } from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

function* getVendorMembers({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorMembersList",
      data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorMembersSuccess(response.data));
    } else {
      yield put(getVendorMembersFailure(response));
      ApiResponseMessage(response.message, DANGER);
    }
  } catch (error) {
    yield put(getVendorMembersFailure(null));
    handleApiCallException(error);
  }
}

export function* watchVendorMembers() {
  yield takeLatest(GET_VENDOR_MEMBERS_REQUEST, getVendorMembers);
}

function* VendorMembersSaga() {
  yield all([fork(watchVendorMembers)]);
}

export default VendorMembersSaga;
